import '../../css/pages/notification_list.less'
window.notifacation = new Vue({
    el: '#app',
    data() {
        return {
            prefix,
            list: [],
            pager:{
                page: 1,
                size: 15,
                total: 0
            },
            keyword:'',
            loading: false,
            headActive: bannerPlateType == 2?true:false,
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        getList(){
            this.loading = true
            API.reqNotifacationList({...this.pager,title:this.keyword}).then(res=>{
                console.log(res)
                if(res.errorCode == 'success'){
                    let list = res.extendMessage.results || []
                    this.list = list.map(el=>{
                        let date = dateFormate(el.releaseTime,'y-m,d')
                        return{
                            ...el,
                            year:date.split(',')[0],
                            day:date.split(',')[1],
                        }
                    })
                    this.pager.total = res.extendMessage.recordTotal
                }
            }).finally(()=>{
                this.loading = false
            })
        },
        handleSearch(){
            this.pager.page = 1;
            this.getList()
        }
    }
})